export default [
    {
        path: '/platinum/pages',
        props: true,
        component: () => import('@/views/PlatinumPage'),
        children: [
            {
                path: ':webpageId',
                component: () => import('@/components/PlatinumPage/Show'),
                props: true,
            },
            {
                path: 'version/:versionId',
                component: () => import('@/components/PlatinumPage/Version'),
                props: true,
            },
        ]
    },


];
